<template>
  <div
    class="mobile-view-not-supported--wrapper flex h-full w-full flex-col items-center justify-center py-5 text-center"
    :class="screenSize"
  >
    <EmptyStateImg
      :empty-state-name="EmptyStateName.NOT_ON_MOBILE"
      class="mb-6"
    />
    <h3 class="font-light">We're sorry but your device isn't supported</h3>
    <h5 class="mt-8">
      You’ll need to access MyJFrog Cloud Portal on your computer
    </h5>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";

import { useGlobalLoaderStore } from "@shared/stores/globalLoader";
import { useScreenSize } from "@shared/use/useScreenSize";
import EmptyStateImg from "@shared/components/cards/EmptyStateImg.vue";
import { EmptyStateName } from "@shared/types/localTypes/empty-states.ts";

const { screenSize } = useScreenSize();

const globalLoaderStore = useGlobalLoaderStore();

onMounted(() => {
  globalLoaderStore.hide();
});
</script>

<style lang="scss" scoped>
@use "@shared/assets/styles/abstracts/functions" as f;

.mobile-view-not-supported--wrapper {
  background-color: f.color("layout-bg-color");

  &.smartphone {
    h3 {
      font-size: 26px;
      width: 80%;
    }

    h5 {
      font-size: 18px;
      width: 70%;
    }
  }

  img {
    height: 20vh;
  }

  h3 {
    font-size: 34px;
    line-height: 36px;
    width: 60%;
    padding: 0 20px;
    color: f.color("text-color-light");
  }

  h5 {
    font-weight: 600;
    font-size: 22px;
    width: 60%;
    color: f.color("text-color-light");
  }

  @media (orientation: landscape) {
    @media screen and (max-height: 500px) {
      h3 {
        font-size: 28px;
      }

      h5 {
        font-size: 20px;
      }

      img {
        max-height: 30vh;
      }
    }
  }
}
</style>
